module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_a-function.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_a-function.js
// module chunks = 6